import * as React from 'react';

export const SolarExportLittle = () => (
  <svg width="128" height="128" viewBox="0 0 128 128">
    <g fill="none">
      <path
        d="M128 64C128 99.3 99.3 128 64 128 28.6 128 0 99.3 0 64 0 28.6 28.6 0 64 0 99.3 0 128 28.6 128 64"
        fill="#F8F8F8"
      />
      <g transform="matrix(-1 0 0 1 106 33)">
        <rect width="12" height="58.8" x="7" fill="#3F75C6" />
        <rect width="12" height="46.2" x="25" y="13" fill="#3F75C6" />
        <rect width="12" height="53.2" x="43" y="6" fill="#3F75C6" />
        <rect width="12" height="49" x="61" y="10" fill="#3F75C6" />
        <rect width="80" height="4" y="59" fill="#D2D2D2" />
        <rect
          width="63"
          height="4"
          x="50.5"
          y="29.5"
          transform="rotate(-90 82 31.5)"
          fill="#D2D2D2"
        />
      </g>
    </g>
  </svg>
);
